import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { PromocodesStore } from './interfaces'

import { isFullArray } from '@helpers/array'

export const getters = {
  isLoading: (state: PromocodesStore): PromocodesStore['loading'] => state.loading,
  isSaving: (state: PromocodesStore): PromocodesStore['saving'] => state.saving,
  getPromocodes: (state: PromocodesStore): PromocodesStore['promocodes'] => state.promocodes,
  hasPromocodes: (state: PromocodesStore): boolean => isFullArray(state.promocodes),
  getMeta: (state: PromocodesStore): Meta | null => state.meta,
  getDiscounts: (state: PromocodesStore): PromocodesStore['discounts'] => state.discounts,
  getFilterSearch: (state: PromocodesStore): PromocodesStore['filterSearch'] => state.filterSearch,
  getFilterStatus: (state: PromocodesStore): PromocodesStore['filterStatus'] => state.filterStatus,
  getFilterDiscount: (state: PromocodesStore): PromocodesStore['filterDiscount'] => state.filterDiscount,
  getFilterFrom: (state: PromocodesStore): PromocodesStore['filterFrom'] => state.filterFrom,
  getFilterTo: (state: PromocodesStore): PromocodesStore['filterTo'] => state.filterTo,
  getCurrentPage: (state: PromocodesStore): PromocodesStore['currentPage'] => state.currentPage,
  getPerPage: (state: PromocodesStore): PromocodesStore['perPage'] => state.perPage,
  getPromocodeToEdit: (state: PromocodesStore): PromocodesStore['promocodeToEdit'] => state.promocodeToEdit,
  isModalEdit: (state: PromocodesStore): boolean => state.promocodeToEdit !== null,
}
